import CryptoJS from "crypto-js";

const SECRET_KEY = "TghGNPsxxU/tQwkM/afrcQ=="; // AMASI

// Make Base64 URL-safe
const base64UrlEncode = (str) => {
  if (typeof str !== "string") {
    console.error("base64UrlEncode: Input must be a string, received:", str);
    return "";
  }
  return str.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

const base64UrlDecode = (str) => {
  if (typeof str !== "string" || !str) {
    console.error("base64UrlDecode: Input must be a non-empty string, received:", str);
    return "";
  }
  let base64 = str.replace(/-/g, "+").replace(/_/g, "/");
  while (base64.length % 4) {
    base64 += "=";
  }
  return base64;
};

export const encryptSlug = (text) => {
  if (typeof text !== "string" || !text) {
    console.error("encryptSlug: Input must be a non-empty string, received:", text);
    return "";
  }
  const encrypted = CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
  return base64UrlEncode(encrypted);
};

export const decryptSlug = (encodedCipherText) => {
  try {
    if (typeof encodedCipherText !== "string" || !encodedCipherText) {
      console.error("decryptSlug: Input must be a non-empty string, received:", encodedCipherText);
      return null;
    }
    const base64Cipher = base64UrlDecode(encodedCipherText);
    if (!base64Cipher) {
      console.error("decryptSlug: Invalid Base64 cipher text");
      return null;
    }
    const bytes = CryptoJS.AES.decrypt(base64Cipher, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    if (!decrypted) {
      console.error("decryptSlug: Decryption resulted in empty string");
      return null;
    }
    return decrypted;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

// import CryptoJS from "crypto-js";

// const SECRET_KEY = "TghGNPsxxU/tQwkM/afrcQ==";//AMASI

// // Make Base64 URL-safe
// const base64UrlEncode = (str) =>
//   str.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

// const base64UrlDecode = (str) => {
//   let base64 = str.replace(/-/g, "+").replace(/_/g, "/");
//   while (base64.length % 4) {
//     base64 += "=";
//   }
//   return base64;
// };

// export const encryptSlug = (text) => {
//   const encrypted = CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
//   return base64UrlEncode(encrypted);
// };

// export const decryptSlug = (encodedCipherText) => {
//   try {
//     const base64Cipher = base64UrlDecode(encodedCipherText);
//     const bytes = CryptoJS.AES.decrypt(base64Cipher, SECRET_KEY);
//     return bytes.toString(CryptoJS.enc.Utf8);
//   } catch (error) {
//     console.error("Decryption failed:", error);
//     return null;
//   }
// };
